export default [
    {
        title: 'Question 1',
        text: 'Do you believe in fate?',
        choices: [
            'Yes, some things are just meant to be.',
            'No, we need to work hard for what we want.',
            'Somewhere in the middle.  Some things are scripted, others are up to chance!',
            'What?  I don\'t know.  I\'m just trying to get by.'
        ],
        values: [
            ['Psychic', 'Fairy', 'Ghost', 'Dragon', 'Ice'],
            ['Steel', 'Fire', 'Rock', 'Dark', 'Flying', 'Poison'],
            ['Water', 'Electric', 'Fighting', 'Ground'],
            ['Normal', 'Grass', 'Bug']
        ]
    },
    {
        title: 'Question 2',
        text: 'A friend you thought you were close with has been saying mean things about you behind your back.  How do you react?',
        choices: [
            'Cry my eyes out!  How could they?',
            'Get angry!  I\'ll never forgive them!',
            'Oh... I guess I\'ll just wallow in my own misery.',
            'Talk it out with them.  I\'m sure they\'ll apologize!',
            'What friend?  I\'ve already moved on.'
        ],
        values: [
            ['Normal', 'Fairy', 'Flying'],
            ['Fire', 'Electric', 'Rock', 'Fighting'],
            ['Grass', 'Ghost', 'Ground'],
            ['Water', 'Steel', 'Psychic'],
            ['Poison', 'Dark', 'Bug', 'Dragon', 'Ice']
        ]
    },
    {
        title: 'Question 3',
        text: 'What kind of music do you like to listen to?',
        choices: [
            'Anything upbeat!',
            'Something relaxed.',
            'Something intense!',
            'Anything with lyrics I can relate to!',
            'I can\'t decide; I change it up every time!'
        ],
        values: [
            ['Electric', 'Fighting', 'Fire'],
            ['Water', 'Grass', 'Ice', 'Ground'],
            ['Dark', 'Poison', 'Dragon', 'Rock'],
            ['Normal', 'Fairy', 'Flying'],
            ['Psychic', 'Bug', 'Steel', 'Ghost']
        ]
    },
    {
        title: 'Question 4',
        text: 'You\'ve been invited to an all-you-can-eat buffet!  What do you start with?',
        choices: [
            'The main protein, like steak!',
            'Veggies or a salad!',
            'Side dishes!',
            'I\'m skipping straight to dessert!',
            'I can\'t decide; it all looks delicious!'
        ],
        values: [
            ['Fighting', 'Rock', 'Steel', 'Dragon'],
            ['Grass', 'Flying', 'Psychic', 'Poison'],
            ['Water', 'Fire', 'Ground'],
            ['Fairy', 'Ice', 'Dark', 'Bug'],
            ['Normal', 'Electric', 'Ghost']
        ]
    },
    {
        title: 'Question 5',
        text: 'Do you wear a watch?',
        choices: [
            'Yes.',
            'No.',
            'Only for the aesthetic, I\'m not actually looking at the time.',
            'If I remember to...'
        ],
        values: [
            ['Psychic', 'Poison', 'Steel', 'Water', 'Ground'],
            ['Normal', 'Rock', 'Fighting', 'Ghost', 'Grass'],
            ['Fairy', 'Ice', 'Dragon', 'Dark'],
            ['Electric', 'Fire', 'Bug', 'Flying']
        ]
    },
    {
        title: 'Question 6',
        text: 'If you were a Pokémon trainer, what would you focus on?',
        choices: [
            'Battles!',
            'Contests and Musicals!',
            'Completing the Pokédex!',
            'Shiny hunting!',
            'Breeding for high stats!',
            'I wouldn\'t have a specific focus; I\'d do whatever I wanted in the moment!'
        ],
        values: [
            ['Steel', 'Fire', 'Rock'],
            ['Fairy', 'Dragon', 'Ghost'],
            ['Bug', 'Grass', 'Ground'],
            ['Dark', 'Poison', 'Electric'],
            ['Psychic', 'Fighting', 'Ice'],
            ['Water', 'Normal', 'Flying']
        ]
    },
    {
        title: 'Question 7',
        text: 'You\'re faced with an enemy who\'s far out of your league.  How do you proceed?',
        choices: [
            'Give it my all in a full-force attack!',
            'Hold steady and chip away at its defenses!',
            'It can\'t hurt me if it can\'t hit me; I\'ll dodge and dive out of its way while hitting it hard!',
            'Retreat and come back with backup!',
            'Try to talk it out!  I\'m sure we can come to an understanding!'
        ],
        values: [
            ['Fire', 'Fighting', 'Dragon'],
            ['Rock', 'Steel', 'Ground', 'Ice'],
            ['Ghost', 'Electric', 'Flying', 'Water'],
            ['Grass', 'Bug', 'Dark', 'Poison'],
            ['Psychic', 'Fairy', 'Normal']
        ]
    },
    {
        title: 'Question 8',
        text: 'You\'re walking home after a late night out, and you hear a strange noise.  How do you react?',
        choices: [
            'Run for it!',
            'Welp, this is it.  This is how I die.  Let\'s just get this over with.',
            'Who\'s out there?! Stop hiding and face me, coward!',
            'That second dessert I had earlier really hit the spot...'
        ],
        values: [
            ['Electric', 'Flying', 'Water', 'Dark', 'Ground'],
            ['Ice', 'Steel', 'Poison', 'Bug'],
            ['Fire', 'Fighting', 'Rock', 'Psychic', 'Dragon'],
            ['Normal', 'Fairy', 'Grass', 'Ghost']
        ]
    },
    {
        title: 'Question 9',
        text: 'How do you like your coffee?',
        choices: [
            'With lots of extras!  They make the experience grand and flavorful!',
            'Plain and simple.  Milk, sugar, or both.',
            'Black.',
            'I\'m fine with water, thanks.'
        ],
        values: [
            ['Fairy', 'Fire', 'Electric', 'Flying'],
            ['Normal', 'Ground', 'Poison', 'Psychic', 'Rock'],
            ['Dark', 'Dragon', 'Ice', 'Fighting', 'Steel'],
            ['Water', 'Grass', 'Bug', 'Ghost']
        ]
    },
    {
        title: 'Question 10',
        text: 'You find a lost wallet.  What do you do with it?',
        choices: [
            'Go straight to the authorities.  They\'ll know what to do.',
            'Leave it alone.  That\'s someone else\'s problem.',
            'Sneak a peek inside.  I wonder if it\'s anyone I know?',
            'Finders keepers!',
            'I\'ll find out where the owner lives, and return it myself!'
        ],
        values: [
            ['Fighting', 'Flying', 'Dragon', 'Steel'],
            ['Water', 'Ice', 'Psychic'],
            ['Normal', 'Electric', 'Bug', 'Fairy'],
            ['Dark', 'Poison', 'Ghost'],
            ['Grass', 'Fire', 'Ground', 'Rock']
        ]
    },
    {
        title: 'Question 11',
        text: 'When was the last time you cleaned your room?',
        choices: [
            'In the last week or so.',
            'More than a week ago, but still recently.',
            'Definitely this year.',
            'It\'s been a very long time.',
            '...'
        ],
        values: [
            ['Water', 'Fighting', 'Dragon', 'Steel'],
            ['Normal', 'Grass', 'Ice', 'Psychic'],
            ['Electric', 'Bug', 'Dark'],
            ['Fire', 'Flying', 'Rock', 'Fairy'],
            ['Poison', 'Ground', 'Ghost']
        ]
    },
    {
        title: 'Question 12',
        text: 'Your crush just asked you out on a date, completely out of nowhere!  What do you do?',
        choices: [
            'Panic!  I wasn\'t prepared for this!',
            'Play it cool.  Don\'t ruin this chance!',
            'Oh my gosh, how exciting!  This is just like a fairy tale...',
            'I always knew they\'d choose me.  It\'s simply impossible not to.',
            'They chose me, out of everyone?  Something smells fishy.'
        ],
        values: [
            ['Normal', 'Electric', 'Psychic'],
            ['Fire', 'Water', 'Grass', 'Rock', 'Steel'],
            ['Fighting', 'Flying', 'Bug', 'Fairy'],
            ['Ice', 'Poison', 'Dragon'],
            ['Dark', 'Ground', 'Ghost']
        ]
    },
    {
        title: 'Question 13',
        text: 'There\'s a fallen tree blocking the road!  What do you do about it?',
        choices: [
            'Try to push it out of the way.  How heavy could a tree be, anyhow?',
            'Call some friends and work together to clear the road.',
            'Oh well.  Bettter find another way around.',
            'Find a saw and start cutting.  Someone\'s gotta do it.',
            'Parkour!'
        ],
        values: [
            ['Fire', 'Fighting', 'Dragon', 'Ghost'],
            ['Bug', 'Fairy', 'Grass', 'Ground', 'Psychic'],
            ['Normal', 'Water', 'Ice', 'Dark'],
            ['Rock', 'Poison', 'Steel'],
            ['Electric', 'Flying']
        ]
    },
    {
        title: 'Question 14',
        text: 'Uh oh, the power just went out.  How do you pass the time?',
        choices: [
            'Who wants to play a board game?  There\'s this cool game called Tranquility...',
            'Ghost stories!  They\'re so much more authentic in the dark.',
            'Guess I\'ll go for a walk.  I wonder if the neighbors lost power, too.',
            'Find a nice, quiet place to be alone with my thoughts.',
            'Guess I\'ll make the most of it and get some chores done.'
        ],
        values: [
            ['Normal', 'Poison', 'Ground', 'Fairy'],
            ['Fire', 'Electric', 'Ghost', 'Dark'],
            ['Grass', 'Fighting', 'Flying', 'Rock'],
            ['Ice', 'Bug', 'Steel'],
            ['Water', 'Psychic', 'Dragon']
        ]
    },
    {
        title: 'Question 15',
        text: 'Life is ________',
        choices: [
            'A challenge.',
            'A mystery.',
            'A journey.',
            'An adventure.',
            'A miracle.',
            'A test.'
        ],
        values: [
            ['Fire', 'Dark', 'Fighting'],
            ['Psychic', 'Ghost', 'Bug'],
            ['Water', 'Ice', 'Flying'],
            ['Grass', 'Electric', 'Fairy'],
            ['Normal', 'Rock', 'Ground'],
            ['Dragon', 'Steel', 'Poison']
        ]
    }
]